<template>
	<div v-loading="loadingPage" style="font-size: 14px;">
		<div>
			<draggable @end="endGrag" style="width: 100%;" v-model="dataList.data"
				:group="{name: 'nav',pull:true,put:true,sort:true}" animation="500">
				<transition-group style="display: flex;background-color: #ffffff;flex-wrap: wrap;">
					<div style="position: relative;margin: 0px 0px;" v-for="(dataItem,dataIndex) in dataList.data"
						:key="dataIndex">
						<div @click="addBtn(dataList.data,dataItem)"
							:style="{backgroundColor:dataItem.addBtn?' #ffffff' :selectItem == dataItem.id?'#8C62FF':'#fff',color:dataItem.addBtn?'#8C62FF':selectItem == dataItem.id?'#fff':'#8C62FF' ,borderRight:dataItem.addBtn?'solid 1px #8C62FF':'none',borderRadius:dataIndex == 0?'8px 0px 0px 8px' :dataIndex ==dataList.data.length - 1?'0px 8px 8px 0px':''}"
							style="text-align: center;width: fit-content;cursor: pointer;position: relative;border-top:solid 1px #8C62FF;border-bottom:solid 1px #8C62FF;border-left:solid 1px #8C62FF;">
							<div
								style="padding: 8px;display: flex;align-items: center;min-width: 120px;justify-content: center;font-size: 14px;">
								<div style="">
									<i v-if="!dataItem.addBtn" class="el-icon-rank"></i>
									{{dataItem.addBtn?'添加主菜单':getText(dataItem)}}
								</div>
								<div @click.stop.prevent="delMain(dataItem,dataIndex,dataList.data)"
									v-if="!dataItem.addBtn" style="margin-left: 10px;">
									<i class="el-icon-delete tit-icon" style="margin-top: 4px;"></i>
								</div>
							</div>
						</div>
					</div>
				</transition-group>
			</draggable>
		</div>
		<div style="margin-left: 5px;" v-for="(dataItem,dataIndex) in dataList.data" :key="dataIndex + '-'">
			<div style="padding: 0px 6px;" v-if="!dataItem.addBtn && selectItem == dataItem.id">
				<div style="display: flex;">
					<div style="margin: 5px;width: 200px;display: flex;flex-direction: column;">
						<div style="display: flex;align-items: center;justify-content: space-between;">
							<div style="margin-top: 10px;">
								主菜单名称/链接
							</div>
						</div>
						<div style="margin-top: 10px;">
							<div style="display: flex;align-items: center;margin-top: 6px;"
								v-for="(item,index) in setLanguage(dataItem.text)" :key="index">
								<img style="width: 38px;height: 25px;" :src="'https://shop910.com/' + item.url" />
								<el-input size="mini" style="width: 200px;margin-left: 10px;" v-model="item.text"
									:placeholder="item.languageName"></el-input>
							</div>
						</div>
					</div>
					<div style="display: flex;margin: 5px;margin-left: 150px;margin-top: 11px;">
						<div style="margin-top: 4px;">
							关联信息
						</div>
						<el-select ref="mySelectOne" @visible-change="handleDropdownOpen($event,'mySelectOne')"
							@clear="clearSelect(dataItem)" clearable size="mini" style="width: 200px;margin-left: 10px;"
							:value="dataItem.linkIndex" placeholder="商品链接">
							<div v-for="optionsItem in options" :key="optionsItem.value">
								<el-option @click.native="changeSelect(optionsItem.value,dataItem,'main')"
									:label="optionsItem.label" :value="optionsItem.value">
								</el-option>
							</div>
						</el-select>
						<div v-if="dataItem.cacheLinkIndex == '商品分类'" style="margin-left: 10px;margin-top: 4px;">
							<el-switch @change="followChildChange($event,dataItem)" style="display: block"
								v-model="dataItem.followChild" active-color="#8C62FF" active-text="子菜单跟随分类子集">
							</el-switch>
						</div>
					</div>
				</div>
				<el-dialog v-if="groupType == 'main'" :close-on-click-modal="false" :title="dataItem.cacheLinkIndex"
					:visible.sync="dialogVisible" width="30%" :before-close="()=>{dialogVisible = false}">
					<el-input @change="changeSearchDialogSearch(dataItem)"
						:placeholder="'请输入搜索' + dataItem.cacheLinkIndex" v-model="dialogSearch">
						<el-button slot="append" icon="el-icon-search"></el-button>
					</el-input>
					<div v-loading="loading">
						<div style="margin-top: 10px;">
							<div v-for="(dialogListItem,dialogListIndex) in dialogList" :key="dialogListIndex">
								<el-radio @input="changeRadio" style="display: flex;align-items: center;padding: 5px;"
									v-model="radio" :label="dialogListIndex" border>
									<div
										style="display: flex;align-items: center;padding: 5px;width: 470px;overflow: hidden;text-overflow:ellipsis; white-space: nowrap;">
										<img v-if="dialogListItem.image_format"
											style="width: 20px;height: 20px;object-fit: cover;"
											:src="dialogListItem.image_format" />
										<span style="margin-left: 10px;">{{dialogListItem.name}}</span>
									</div>
								</el-radio>
							</div>
						</div>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible = false">取 消</el-button>
						<el-button style="background-color: #8C62FF;color: #ffffff;" @click="confirmSelect(dataItem)">确
							定</el-button>
					</span>
				</el-dialog>
				<el-dialog v-if="groupType == 'main'" :close-on-click-modal="false" title="自定义"
					:visible.sync="customerVisible" width="30%" :before-close="()=>{customerVisible = false}">
					<!-- <el-radio v-model="customerRadio" label="站内链接">站内链接</el-radio>
					<el-radio v-model="customerRadio" label="外部链接">外部链接</el-radio> -->
					<el-input v-model="customerInput" style="margin-top: 20px;" placeholder="请输入内容"></el-input>
					<span slot="footer" class="dialog-footer">
						<el-button @click="customerVisible = false">取 消</el-button>
						<el-button style="background-color: #8C62FF;color: #ffffff;"
							@click="confirmCustomerSelect(dataItem)">确
							定</el-button>
					</span>
				</el-dialog>
				<div style="width: 100%;padding: 10px 0px;margin-top: 30px;">
					<div style="display: flex;align-items: center;">
						<div v-if="!dataItem.followChild ||  dataItem.cacheLinkIndex != '商品分类'"
							style="display: flex;align-items: center;margin-right: 20px;">
							<div>
								子菜单(组)
							</div>
							<el-button
								style="margin-left: 10px;background-color: #8C62FF;border: none;font-weight: bold;"
								size="mini" @click="addChild(dataItem)" type="primary">添加菜单组</el-button>

						</div>
						<div>
							是否全屏 <el-switch style="margin-left: 4px;" v-model="dataItem.config.isFull"
								active-color="#13ce66" inactive-color="#ff4949">
							</el-switch>
						</div>
					</div>

					<div
						v-if="(dataItem.child.length > 0 && dataItem.config) || (dataItem.followChild &&  dataItem.cacheLinkIndex == '商品分类')">
						<div v-if="!dataItem.config.isFull" style="display: flex;align-items: center;margin-top: 10px;">
							<div style="font-size: 14px;">盒装宽度</div>
							<el-input style="width: 200px;margin-left: 10px;" size="mini" :placeholder="'请输入盒装宽度'"
								v-model="dataItem.config.width">
							</el-input>
						</div>

						<div style="display: flex;align-items: center;">
							<div style="display: flex;align-items: center;margin-top: 10px;">
								<div style="font-size: 14px;">子标题颜色</div>
								<el-color-picker size="small" style="margin-left: 10px;"
									v-model="dataItem.config.titColor"></el-color-picker>
							</div>
							<div style="display: flex;align-items: center;margin-top: 10px;margin-left: 10px;">
								<div style="font-size: 14px;">子标题大小</div>
								<el-input style="width: 110px;margin-left: 10px;" size="mini" :placeholder="'子标题大小'"
									v-model="dataItem.config.titFontSize">
								</el-input>
							</div>
							<div style="display: flex;align-items: center;margin-top: 10px;margin-left: 10px;">
								<div style="font-size: 14px;">字体大小</div>
								<el-input style="width:110px;margin-left: 10px;" size="mini" :placeholder="'字体大小'"
									v-model="dataItem.config.titChildFontSize">
								</el-input>
							</div>
						</div>

						<div style="display: flex;align-items: center;">
							<div style="display: flex;align-items: center;margin-top: 10px;">
								<div style="font-size: 14px;">背景设置</div>
								<div style="display: flex;align-items: center;margin-left: 10px;">
									<div @click="dataItem.config.bg.bgType = 'color'"
										:style="{backgroundColor:dataItem.config.bg.bgType == 'color'?'#8c62ff':'#fff',color:dataItem.config.bg.bgType == 'color'?'#fff':'#000',border:dataItem.config.bg.bgType == 'color'?'solid 1px #8c62ff':'solid 1px #959595' }"
										style="padding: 4px 0px;width: 68px;text-align: center;cursor: pointer;">
										<span style="scale: 0.85;">纯色背景</span>
									</div>
									<div @click="dataItem.config.bg.bgType = 'gradient'"
										:style="{backgroundColor:dataItem.config.bg.bgType == 'gradient'?'#8c62ff':'#fff',color:dataItem.config.bg.bgType == 'gradient'?'#fff':'#000',border:dataItem.config.bg.bgType == 'gradient'?'solid 1px #8c62ff':'solid 1px #959595' }"
										style="padding: 4px 0px;width: 68px;text-align: center;cursor: pointer;">
										<span style="scale: 0.85;">渐变背景</span>
									</div>
								</div>
							</div>
							<div v-if="dataItem.config.bg.bgType == 'color'"
								style="display: flex;align-items: center;margin-top: 10px;margin-left: 10px;">
								<div style="font-size: 14px;">背景纯色设置</div>
								<el-color-picker size="small" style="margin-left: 10px;"
									v-model="dataItem.config.bg.bgColor"></el-color-picker>
							</div>
							<div v-if="dataItem.config.bg.bgType == 'gradient'"
								style="display: flex;align-items: center;margin-top: 10px;margin-left: 10px;">
								<div style="font-size: 14px;">背景渐变设置</div>
								<div style="margin-left: 10px;">
									<div style="display: flex;flex-direction: column;">
										<el-input size="small" style="width: 260px;margin-top: 4px;" type="textarea"
											:rows="1" placeholder="请输入内容" v-model="dataItem.config.bg.bgGradient">
										</el-input>
									</div>
									<div style="margin-top: 6px;font-size: 12px;color: #55aaff;transform: scale(0.85);">
										需要自定义模板设置请访问 <a target="_blank" style="margin-left: 4px;"
											href="https://www.eggradients.com/gradient-maker">gradient-maker</a>
									</div>
								</div>
							</div>
						</div>

						<div style="display: flex;align-items: center;margin-top: 10px;">
							<div style="" class="flex-item-center" style="align-items: center;display: flex;">
								<div style="font-size: 14px;">组件边框</div>
								<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
									<div @click="dataItem.config.border.type = ''"
										:style="{backgroundColor: dataItem.config.border.type == ''?'#8c62ff':'#fff',color: dataItem.config.border.type == ''?'#fff':'#000',border: dataItem.config.border.type == ''?'solid 1px #8c62ff':'solid 1px #959595' }"
										style="padding: 4px 0px;width: 36px;text-align: center;">
										<span style="scale: 0.85;">无</span>
									</div>
									<div @click="dataItem.config.border.type = 'solid'"
										:style="{backgroundColor: dataItem.config.border.type == 'solid'?'#8c62ff':'#fff',color: dataItem.config.border.type == 'solid'?'#fff':'#000',border: dataItem.config.border.type == 'solid'?'solid 1px #8c62ff':'solid 1px #959595' }"
										style="padding: 4px 0px;width: 36px;text-align: center;">
										<span style="scale: 0.85;">实线</span>
									</div>
									<div @click="dataItem.config.border.type = 'dashed'"
										:style="{backgroundColor:dataItem.config.border.type == 'dashed'?'#8c62ff':'#fff',color:dataItem.config.border.type == 'dashed'?'#fff':'#000',border:dataItem.config.border.type == 'dashed'?'solid 1px #8c62ff':'solid 1px #959595' }"
										style="padding: 4px 0px;width: 36px;text-align: center;">
										<span style="scale: 0.85;">虚线</span>
									</div>
								</div>
							</div>

							<div style="" class="flex-item-center"
								style="align-items: center;display: flex;margin-left: 10px;">
								<div style="font-size: 14px;">边框颜色</div>
								<el-color-picker size="mini"
									style="height: 34px;width: 34px;margin-left: 10px;margin-top: 10px;"
									v-model="dataItem.config.border.color"></el-color-picker>

								<div style="" class="flex-item-center" style="align-items: center;display: flex;">
									<div v-if="dataItem.config.border.borderSize"
										style="display: flex;align-items: center;margin-left: 10px;">
										<div>线条大小</div>
										<div
											style="display: flex;align-items: center;justify-content: space-between;margin-left: 10px;">
											<div style="display: flex;flex-direction: column;align-items: center;">
												<input @input="levelChangeContainerSize($event,dataItem.config)"
													v-model="dataItem.config.border.borderSize[0]"
													style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
												<div style="margin-top: 2px;">顶部</div>
											</div>
											<div style="display: flex;flex-direction: column;align-items: center;">
												<input @input="levelChangeContainerSize($event,dataItem.config)"
													v-model="dataItem.config.border.borderSize[1]"
													style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
												<div style="margin-top: 2px;">左侧</div>
											</div>
											<div style="display: flex;flex-direction: column;align-items: center;">
												<input @input="levelChangeContainerSize($event,dataItem.config)"
													v-model="dataItem.config.border.borderSize[2]"
													style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
												<div style="margin-top: 2px;">底部</div>
											</div>
											<div style="display: flex;flex-direction: column;align-items: center;">
												<input @input="levelChangeContainerSize($event,dataItem.config)"
													v-model="dataItem.config.border.borderSize[3]"
													style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
												<div style="margin-top: 2px;">右侧</div>
											</div>
											<div
												style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
												<i @click="borderContainerSizeAll = !borderContainerSizeAll"
													:style="{color:borderContainerSizeAll?'#8c62ff':'#000'}"
													style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
													class="el-icon-paperclip tit-icon"></i>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div style="display: flex;align-items: center;margin-top: 10px;">
							<div style="" class="flex-item-center" style="align-items: center;display: flex;">
								<div>内边距</div>
								<div
									style="display: flex;align-items: center;justify-content: space-between;margin-left: 10px;">
									<div style="display: flex;flex-direction: column;align-items: center;">
										<input @input="paddingSet($event,dataItem.config)"
											v-model="dataItem.config.padding[0]"
											style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
										<div style="margin-top: 2px;">顶部</div>
									</div>
									<div style="display: flex;flex-direction: column;align-items: center;">
										<input @input="paddingSet($event,dataItem.config)"
											v-model="dataItem.config.padding[1]"
											style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
										<div style="margin-top: 2px;">左侧</div>
									</div>
									<div style="display: flex;flex-direction: column;align-items: center;">
										<input @input="paddingSet($event,dataItem.config)"
											v-model="dataItem.config.padding[2]"
											style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
										<div style="margin-top: 2px;">底部</div>
									</div>
									<div style="display: flex;flex-direction: column;align-items: center;">
										<input @input="paddingSet($event,dataItem.config)"
											v-model="dataItem.config.padding[3]"
											style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
										<div style="margin-top: 2px;">右侧</div>
									</div>
									<div
										style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
										<i @click="paddingAll = !paddingAll"
											:style="{color:paddingAll?'#8c62ff':'#000'}"
											style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
											class="el-icon-paperclip tit-icon"></i>
									</div>
								</div>
							</div>

							<!-- <div style="" class="flex-item-center"
								style="align-items: center;display: flex;">
								<div>外边距</div>
								<div
									style="display: flex;align-items: center;justify-content: space-between;margin-left: 10px;">
									<div style="display: flex;flex-direction: column;align-items: center;">
										<input @input="marginSet($event,dataItem.config)" v-model="dataItem.config.margin[0]"
											style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
										<div style="margin-top: 2px;">顶部</div>
									</div>
									<div style="display: flex;flex-direction: column;align-items: center;">
										<input @input="marginSet($event,dataItem.config)" v-model="dataItem.config.margin[1]"
											style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
										<div style="margin-top: 2px;">左侧</div>
									</div>
									<div style="display: flex;flex-direction: column;align-items: center;">
										<input @input="marginSet($event,dataItem.config)" v-model="dataItem.config.margin[2]"
											style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
										<div style="margin-top: 2px;">底部</div>
									</div>
									<div style="display: flex;flex-direction: column;align-items: center;">
										<input @input="marginSet($event,dataItem.config)" v-model="dataItem.config.margin[3]"
											style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
										<div style="margin-top: 2px;">右侧</div>
									</div>
									<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
										<i @click="marginAll = !marginAll" :style="{color:marginAll?'#8c62ff':'#000'}"
											style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
											class="el-icon-paperclip tit-icon"></i>
									</div>
								</div>
							</div> -->
						</div>

					</div>



					<draggable v-if="!dataItem.followChild ||  dataItem.cacheLinkIndex != '商品分类'" @end="endGrag"
						style="width: 100%;" v-model="dataItem.child"
						:group="{name: 'navChild',pull:true,put:true,sort:true}" animation="500">
						<transition-group
							style="display: flex;flex-wrap: wrap;background-color: #f4f4f4;margin-top: 10px;">

							<div style="border: #959595 solid 1px;width: 350px;background-color: #ffffff;margin: 30px 10px;"
								v-for="(childItem,childIndex) in dataItem.child" :key="childIndex">
								<div
									style="display: flex;align-items: center;justify-content: space-between;position: relative;">
									<div style="margin: 10px;display: flex;align-items: center;">
										<!-- <div>
										菜单-{{childIndex + 1}}-{{childItem.type == '1'?'链接':'图片'}}
									</div> -->
										<i class="el-icon-rank"></i>
										<div style="margin-left: 10px;">
											{{getText(childItem)}}
										</div>
										<div @click.stop.prevent="delMain(childItem,childIndex,dataItem.child)"
											v-if="!dataItem.addBtn"
											style="margin-left: 10px;font-size: 18px;cursor: pointer;">
											<i class="el-icon-delete tit-icon"></i>
										</div>
									</div>

									<div
										style="display: flex;align-items: center;position: absolute;top: 0px;right: 0px;">
										<div @click="childItem.type = 1"
											:style="{backgroundColor:childItem.type == 1?'#8C62FF':'#fff',color:childItem.type == 1?'#fff':'#8C62FF'}"
											style="border: #8C62FF solid 1px;padding: 4px 5px;cursor: pointer;">链接</div>
										<div @click="childItem.type = 2"
											:style="{backgroundColor:childItem.type == 2?'#8C62FF':'#fff',color:childItem.type == 2?'#fff':'#8C62FF'}"
											style="border: #8C62FF solid 1px;padding: 4px 5px;cursor: pointer;">图片</div>

									</div>
								</div>
								<div style="display: flex;align-items: center;justify-content: center;">
									<div>
										宽度设置
									</div>
									<div style="margin-left: 10px;">
										<el-input size="mini" style="width: 152px;" placeholder="请输入宽度"
											v-model="childItem.configWidth">
										</el-input>
									</div>
								</div>
								<div>
									<div>
										<div style="display: flex;align-items: center;margin-top: 6px;justify-content: center;"
											v-for="(item,index) in setLanguage(childItem.text)" :key="index">
											<img style="width: 38px;height: 25px;object-fit: contain;"
												:src="'https://shop910.com/' + item.url" />
											<el-input size="mini" style="width: 180px;margin-left: 0px;"
												v-model="item.text" :placeholder="item.languageName"></el-input>
										</div>
									</div>
								</div>
								<div style="margin-top: 10px;" v-if="childItem.type == '2'">
									<div :key="imgItem.language" v-for="(imgItem, imgIndex) in  childItem.imgLink">
										<div v-if="!imgItem.img.url" style="margin-top: 10px;">
											<div
												style="margin: 10px 50px;border: solid 1px #5f5f5f;display: flex;align-items: center;">
												<img style="width: 38px;height: 25px;"
													:src="'https://shop910.com/' + imgItem.url" />
												<div @click="dialogVisibleImgs = true;selectIndex = imgIndex + 'imgIndex';subChildIndex = childIndex;"
													style="border: solid 1px; width: 23px;height: 23px;display: flex;align-items: center;justify-content: center;cursor: pointer;margin-left: 10px;">
													<i class="el-icon-plus"></i>
												</div>
											</div>
										</div>
										<div v-if="imgItem.img.url"
											style="display: flex;align-items: center;margin-top: 10px;margin: 10px 50px;border: solid 1px #5f5f5f;">
											<img style="width: 38px;height: 25px;"
												:src="'https://shop910.com/' + imgItem.url" />
											<div style="border: solid 1px; width: 23px;height: 23px;display: flex;align-items: center;justify-content: center;cursor: pointer;margin-left: 10px;"
												v-if="imgItem.img.url">
												<img :src="imgItem.img.url" style="width: 23px;height: 23px;" />
											</div>
											<div @click="delImg(imgItem,childItem)"
												style="margin-left: 20px;cursor: pointer;" class="tit-icon">删除</div>
										</div>
										<el-dialog
											v-if="selectIndex == imgIndex + 'imgIndex' && subChildIndex == childIndex"
											:modal="false" custom-class="select-imgs" title="文件管理器"
											:visible.sync="dialogVisibleImgs" width="80%"
											:before-close="()=>{dialogVisibleImgs = false}">
											<select-img style="height: 70vh"
												@confirmImg="confirmSelectImg($event,'dialogVisibleImgs',imgItem)"
												v-if="dialogVisibleImgs"></select-img>
										</el-dialog>
										<el-select :key="selectKey" ref="mySelectTwo"
											@visible-change="handleDropdownOpen($event,'mySelectTwo')" size="mini"
											v-if="childItem.imgLink.length - 1 == imgIndex"
											style="width: 150px;margin-left: 170px;margin-bottom: 10px;"
											:value="childItem.imgLink[childItem.imgLink.length - 1].link.linkIndex">
											<div v-for="optionsItem in options" :key="optionsItem.value">
												<el-option
													@click.native="changeSelect(optionsItem.value,childItem.imgLink[childItem.imgLink.length - 1].link,'child');subChildIndex = childIndex;selectIndex = imgIndex + 'imgIndex'"
													:label="optionsItem.label" :value="optionsItem.value">
												</el-option>
											</div>
										</el-select>
										<el-dialog :modal="false"
											v-if="groupType == 'child' && childItem.imgLink.length - 1 == imgIndex && subChildIndex == childIndex && selectIndex == imgIndex + 'imgIndex'"
											:close-on-click-modal="false" :title="dataItem.cacheLinkIndex"
											:visible.sync="dialogVisible" width="30%"
											:before-close="()=>{dialogVisible = false}">
											<el-input @change="changeSearchDialogSearch(imgItem.link)"
												:placeholder="'请输入搜索' + dataItem.cacheLinkIndex" v-model="dialogSearch">
												<el-button slot="append" icon="el-icon-search"></el-button>
											</el-input>
											<div v-loading="loading">
												<div style="margin-top: 10px;">
													<div v-for="(dialogListItem,dialogListIndex) in dialogList"
														:key="dialogListIndex">
														<el-radio @input="changeRadio"
															style="display: flex;align-items: center;padding: 5px;"
															v-model="radio" :label="dialogListIndex" border>
															<div
																style="display: flex;align-items: center;padding: 5px;width: 470px;overflow: hidden;text-overflow:ellipsis; white-space: nowrap;">
																<img v-if="dialogListItem.image_format"
																	style="width: 20px;height: 20px;object-fit: cover;"
																	:src="dialogListItem.image_format" />
																<span
																	style="margin-left: 10px;">{{dialogListItem.name}}</span>
															</div>
														</el-radio>
													</div>
												</div>
											</div>
											<span slot="footer" class="dialog-footer">
												<el-button @click="dialogVisible = false">取 消</el-button>
												<el-button style="background-color: #8C62FF;color: #ffffff;"
													@click="confirmSelect(childItem.imgLink[childItem.imgLink.length - 1].link)">确
													定</el-button>
											</span>
										</el-dialog>

										<el-dialog :modal="false"
											v-if="groupType == 'child' && childItem.imgLink.length - 1 == imgIndex &&  subChildIndex == childIndex && selectIndex == imgIndex + 'imgIndex'"
											:close-on-click-modal="false" title="自定义" :visible.sync="customerVisible"
											width="30%" :before-close="()=>{customerVisible = false}">
											<!-- <el-radio v-model="customerRadio" label="站内链接">站内链接</el-radio>
										<el-radio v-model="customerRadio" label="外部链接">外部链接</el-radio> -->
											<el-input v-model="customerInput" style="margin-top: 20px;"
												placeholder="请输入内容"></el-input>
											<span slot="footer" class="dialog-footer">
												<el-button @click="customerVisible = false">取 消</el-button>
												<el-button style="background-color: #8C62FF;color: #ffffff;"
													@click="confirmCustomerSelect(childItem.imgLink[childItem.imgLink.length - 1].link)">确
													定</el-button>
											</span>
										</el-dialog>
									</div>
									<!-- <el-tabs value="zh_cn" type="card">
									<el-tab-pane :key="imgItem.language"
										v-for="(imgItem, imgIndex) in  childItem.imgLink" :label="imgItem.languageName"
										:name="imgItem.language">
										<div v-if="!imgItem.img.url">
											<div style="background-color: #f5f5f5;padding: 10px;">
												<div @click="dialogVisibleImgs = true;selectIndex = imgIndex + 'imgIndex'"
													style="border: solid 1px; width: 40px;height: 40px;display: flex;align-items: center;justify-content: center;cursor: pointer;">
													<i class="el-icon-plus"></i>
												</div>
											</div>
										</div>
										<div v-if="imgItem.img.url"
											style="background-color: #f5f5f5;padding: 10px;display: flex;align-items: center;">
											<div style="border: solid 1px; width: 40px;height: 40px;display: flex;align-items: center;justify-content: center;cursor: pointer;"
												v-if="imgItem.img.url">
												<img :src="imgItem.img.url" style="width: 40px;height: 40px;" />
											</div>
											<div @click="delImg(imgItem,childItem)"
												style="margin-left: 20px;cursor: pointer;" class="tit-icon">删除</div>
										</div>
										<el-dialog v-if="selectIndex == imgIndex + 'imgIndex'" :modal="false"
											custom-class="select-imgs" title="文件管理器" :visible.sync="dialogVisibleImgs"
											width="80%" :before-close="()=>{dialogVisibleImgs = false}">
											<select-img style="height: 70vh"
												@confirmImg="confirmSelectImg($event,'dialogVisibleImgs',imgItem)"
												v-if="dialogVisibleImgs"></select-img>
										</el-dialog>
										<el-select style="width: 300px;margin-top: 10px;"
											:value="imgItem.link.linkIndex">
											<div v-for="optionsItem in options" :key="optionsItem.value">
												<el-option
													@click.native="changeSelect(optionsItem.value,imgItem.link,'child')"
													:label="optionsItem.label" :value="optionsItem.value">
												</el-option>
											</div>
										</el-select>
										<el-dialog :modal="false"
											v-if="groupType == 'child' && selectIndex == imgIndex + 'imgIndex'"
											:close-on-click-modal="false" :title="dataItem.cacheLinkIndex"
											:visible.sync="dialogVisible" width="30%"
											:before-close="()=>{dialogVisible = false}">
											<el-input @change="changeSearchDialogSearch(imgItem.link)"
												placeholder="请输入搜索商品名称" v-model="dialogSearch">
												<el-button slot="append" icon="el-icon-search"></el-button>
											</el-input>
											<div v-loading="loading">
												<div style="margin-top: 10px;">
													<div v-for="(dialogListItem,dialogListIndex) in dialogList"
														:key="dialogListIndex">
														<el-radio @input="changeRadio"
															style="display: flex;align-items: center;padding: 5px;"
															v-model="radio" :label="dialogListIndex" border>
															<div
																style="display: flex;align-items: center;padding: 5px;width: 470px;overflow: hidden;text-overflow:ellipsis; white-space: nowrap;">
																<img v-if="dialogListItem.image_format"
																	style="width: 20px;height: 20px;object-fit: cover;"
																	:src="dialogListItem.image_format" />
																<span
																	style="margin-left: 10px;">{{dialogListItem.name}}</span>
															</div>
														</el-radio>
													</div>
												</div>
											</div>
											<span slot="footer" class="dialog-footer">
												<el-button @click="dialogVisible = false">取 消</el-button>
												<el-button style="background-color: #8C62FF;color: #ffffff;"
													@click="confirmSelect(imgItem.link)">确
													定</el-button>
											</span>
										</el-dialog>
										<el-dialog :modal="false"
											v-if="groupType == 'child' && selectIndex == imgIndex + 'imgIndex'"
											:close-on-click-modal="false" title="自定义" :visible.sync="customerVisible"
											width="30%" :before-close="()=>{customerVisible = false}">
											<el-radio v-model="customerRadio" label="站内链接">站内链接</el-radio>
											<el-radio v-model="customerRadio" label="外部链接">外部链接</el-radio>
											<el-input v-model="customerInput" style="margin-top: 20px;"
												placeholder="请输入内容"></el-input>
											<span slot="footer" class="dialog-footer">
												<el-button @click="customerVisible = false">取 消</el-button>
												<el-button style="background-color: #8C62FF;color: #ffffff;"
													@click="confirmCustomerSelect(imgItem.link)">确
													定</el-button>
											</span>
										</el-dialog>
									</el-tab-pane>
								</el-tabs> -->
								</div>
								<div v-if="childItem.type == '1'" style="padding: 10px;">
									<div style="margin-top: 20px;"
										v-for="(childLinkItem,childLinkIndex) in childItem.links" :key="childLinkIndex">
										<div style="display: flex;align-items: flex-end;" v-if="childLinkItem.linkList">
											<div>
												<div style="display: flex;align-items: center;margin-top: 5px;"
													v-for="(childLinkTextItem,childLinkIndexItem) in childLinkItem.linkList"
													:key="childLinkIndexItem">
													<img style="width: 38px;height: 25px;object-fit: fill;"
														:src="'https://shop910.com/' + childLinkTextItem.url" />
													<el-input size="mini" style="width: 120px;"
														v-model="childLinkTextItem.text"
														:placeholder="childLinkTextItem.languageName"></el-input>
												</div>
											</div>
											<div style="display: flex;align-items: center;margin-left: 10px;">
												<el-select :style="selectKey" ref="mySelect"
													@visible-change="handleDropdownOpen($event,'mySelect')" size="mini"
													placeholder="链接选择" style="width: 120px;"
													:value="childLinkItem.linkIndex">
													<div v-for="optionsItem in options" :key="optionsItem.value">
														<el-option
															@click.native="changeSelect(optionsItem.value,childLinkItem,'child');selectIndex = childLinkIndex + 'childLinkIndex';subChildIndex = childIndex"
															:label="optionsItem.label" :value="optionsItem.value">
														</el-option>
													</div>
												</el-select>
												<i @click="()=>{
												childItem.links.splice(childLinkIndex,1)
											}" style="margin-left: 6px;font-size: 18px;cursor: pointer;" class="el-icon-delete tit-icon"></i>
											</div>
										</div>

										<el-dialog
											v-if="groupType == 'child' && selectIndex == childLinkIndex + 'childLinkIndex' && subChildIndex == childIndex"
											:close-on-click-modal="false" :title="childLinkItem.cacheLinkIndex"
											:visible.sync="dialogVisible" width="30%"
											:before-close="()=>{dialogVisible = false}">
											<el-input @change="changeSearchDialogSearch(childLinkItem)"
												:placeholder="'请输入搜索' + childLinkItem.cacheLinkIndex"
												v-model="dialogSearch">
												<el-button slot="append" icon="el-icon-search"></el-button>
											</el-input>
											<div v-loading="loading">
												<div style="margin-top: 10px;">
													<div v-for="(dialogListItem,dialogListIndex) in dialogList"
														:key="dialogListIndex">
														<el-radio @input="changeRadio"
															style="display: flex;align-items: center;padding: 5px;"
															v-model="radio" :label="dialogListIndex" border>
															<div
																style="display: flex;align-items: center;padding: 5px;width: 470px;overflow: hidden;text-overflow:ellipsis; white-space: nowrap;">
																<img v-if="dialogListItem.image_format"
																	style="width: 20px;height: 20px;object-fit: cover;"
																	:src="dialogListItem.image_format" />
																<span
																	style="margin-left: 10px;">{{dialogListItem.name}}</span>
															</div>
														</el-radio>
													</div>
												</div>
											</div>
											<span slot="footer" class="dialog-footer">
												<el-button @click="dialogVisible = false">取 消</el-button>
												<el-button style="background-color: #8C62FF;color: #ffffff;"
													@click="confirmSelect(childLinkItem)">确
													定</el-button>
											</span>
										</el-dialog>
										<el-dialog
											v-if="groupType == 'child' && selectIndex == childLinkIndex + 'childLinkIndex' &&  subChildIndex == childIndex"
											:close-on-click-modal="false" title="自定义" :visible.sync="customerVisible"
											width="30%" :before-close="()=>{customerVisible = false}">
											<!-- <el-radio v-model="customerRadio" label="站内链接">站内链接</el-radio>
										<el-radio v-model="customerRadio" label="外部链接">外部链接</el-radio> -->
											<el-input v-model="customerInput" style="margin-top: 20px;"
												placeholder="请输入内容"></el-input>
											<span slot="footer" class="dialog-footer">
												<el-button @click="customerVisible = false">取 消</el-button>
												<el-button style="background-color: #8C62FF;color: #ffffff;"
													@click="confirmCustomerSelect(childLinkItem)">确
													定</el-button>
											</span>
										</el-dialog>
									</div>
								</div>
								<div v-if="childItem.type == '1'" @click="addChildLink(childItem)"
									style="margin-top: 10px;color: #00aaff;cursor: pointer;margin: 6px;">
									添加子菜单链接
								</div>
							</div>
						</transition-group>
					</draggable>
				</div>
			</div>
		</div>
		<el-dialog title="提示" :visible.sync="languageDialogVisible" width="30%"
			:before-close="()=>{languageDialogVisible = false}">
			<div>
				<div style="display: flex;align-items: center;margin-top: 6px;" v-for="(item,index) in languageList"
					:key="index">
					<div style="width: 100px;">
						{{item.languageName}}
					</div>
					<el-input style="width: 200px;" v-model="item.text" placeholder="请输入主菜单语言名称"></el-input>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="languageDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="languageDialogVisible = false">设置完成</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import draggable from 'vuedraggable'
	import selectImg from '../components/selectImg.vue'
	import lodash from 'lodash';
	let obj = {
		text: [{
				language: "zh_cn",
				languageName: "中文",
				text: ""
			},
			{
				language: "en",
				languageName: "英文",
				text: ""
			},
			{
				language: "zh_hk",
				languageName: "繁体中文",
				text: ""
			},
			{
				language: "ja",
				languageName: "Japanese",
				text: ""
			},
			{
				language: "ko",
				languageName: "간체 중문",
				text: ""
			},
			{
				language: "de",
				languageName: "Deutsch",
				text: ""
			},
			{
				language: "es",
				languageName: "Espanol",
				text: ""
			},
			{
				language: "fr",
				languageName: "French",
				text: ""
			},
			{
				language: "id",
				languageName: "Indonesia",
				text: ""
			},
			{
				language: "it",
				languageName: "Italiano",
				text: ""
			},
			{
				language: "ru",
				languageName: "Русский",
				text: ""
			}
		],
		link: {},
		linkIndex: '',
		cacheLinkIndex: '',
		color1: "",
		color2: "",
		label: [{
				language: "zh_cn",
				languageName: "中文",
				text: ""
			},
			{
				language: "en",
				languageName: "英文",
				text: ""
			},
			{
				language: "zh_hk",
				languageName: "繁体中文",
				text: ""
			},
			{
				language: "ja",
				languageName: "Japanese",
				text: ""
			},
			{
				language: "ko",
				languageName: "간체 중문",
				text: ""
			},
			{
				language: "de",
				languageName: "Deutsch",
				text: ""
			},
			{
				language: "es",
				languageName: "Espanol",
				text: ""
			},
			{
				language: "fr",
				languageName: "French",
				text: ""
			},
			{
				language: "id",
				languageName: "Indonesia",
				text: ""
			},
			{
				language: "it",
				languageName: "Italiano",
				text: ""
			},
			{
				language: "ru",
				languageName: "Русский",
				text: ""
			}
		],
		isFull: false,
		child: []
	}
	let childObj = {
		links: [],
		type: "1",
		imgLink: [{
				language: "zh_cn",
				languageName: "中文",
				link: {},
				img: {}
			},
			{
				language: "en",
				languageName: "英文",
				link: {},
				img: {}
			},
			{
				language: "zh_hk",
				languageName: "繁体中文",
				link: {},
				img: {}
			},
			{
				language: "ja",
				languageName: "Japanese",
				link: {},
				img: {}
			},
			{
				language: "ko",
				languageName: "간체 중문",
				link: {},
				img: {}
			},
			{
				language: "de",
				languageName: "Deutsch",
				link: {},
				img: {}
			},
			{
				language: "es",
				languageName: "Espanol",
				link: {},
				img: {}
			},
			{
				language: "fr",
				languageName: "French",
				link: {},
				img: {}
			},
			{
				language: "id",
				languageName: "Indonesia",
				link: {},
				img: {}
			},
			{
				language: "it",
				languageName: "Italiano",
				link: {},
				img: {}
			},
			{
				language: "ru",
				languageName: "Русский",
				link: {},
				img: {}
			}
		],
		text: [{
				language: "zh_cn",
				languageName: "中文",
				text: ""
			},
			{
				language: "en",
				languageName: "英文",
				text: ""
			},
			{
				language: "zh_hk",
				languageName: "繁体中文",
				text: ""
			},
			{
				language: "ja",
				languageName: "Japanese",
				text: ""
			},
			{
				language: "ko",
				languageName: "간체 중문",
				text: ""
			},
			{
				language: "de",
				languageName: "Deutsch",
				text: ""
			},
			{
				language: "es",
				languageName: "Espanol",
				text: ""
			},
			{
				language: "fr",
				languageName: "French",
				text: ""
			},
			{
				language: "id",
				languageName: "Indonesia",
				text: ""
			},
			{
				language: "it",
				languageName: "Italiano",
				text: ""
			},
			{
				language: "ru",
				languageName: "Русский",
				text: ""
			}
		],
	}

	import {
		getProductsAutocomplete,
		getCategoriesAutocomplete,
		getPagesAutocomplete,
		getPageCategoriesAutocomplete,
		getBrandsAutocomplete,
		designCategoriesSonCategory
	} from '../../api/all.js'
	export default {
		components: {
			selectImg,
			draggable
		},
		props: {

			itemId: {
				default: ''
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},

			boxWidth: {
				type: Number,
				default: 0
			},
			dataList: {
				type: Object,
				default: () => {
					return {
						// data: []
					}
				}
			},
		},
		watch: {
			// itemId: function(newV, oldV) {
			// 	if(this.first) {
			// 		this.selectItem = newV
			// 		this.first = false
			// 	}
			// },
			// dataList: {
			// 	deep: true,
			// 	handler: function(newVal, oldVal) {
			// 		console.log('newValdataList', newVal)
			// 		this.$emit('changeList',newVal)
			// 	}
			// }
		},
		data() {
			return {
				loadingPage: false,
				marginAll: true,
				paddingAll: true,
				borderContainerSizeAll: true,
				subChildIndex: 0,
				selectKey: 1,
				languageList: [],
				languageListType: "",
				languageDialogVisible: false,
				selectIndex: 0,
				dialogVisibleImgs: false,
				groupType: "main",
				customerInput: "",
				customerRadio: "站内链接",
				customerVisible: false,
				categoriesDialogVisible: false,
				categoriesSearch: "",
				categoriesList: [],
				loading: false,
				radio: "",
				dialogList: [],
				dialogSearch: "",
				dialogVisible: false,
				options: [{
						label: "无",
						value: '无'
					},
					{
						label: "商品分类",
						value: '商品分类'
					},
					{
						label: "商品",
						value: '商品'
					},

					{
						label: "热销商品",
						value: '热销商品'
					},
					{
						label: "最新商品",
						value: '最新商品'
					},
					{
						label: "浏览最多",
						value: '浏览最多'
					},

					{
						label: "所有商品",
						value: '所有商品'
					},
					{
						label: "首页",
						value: '首页'
					},
					{
						label: "搜索页面",
						value: '搜索页面'
					},
					{
						label: "品牌列表",
						value: '品牌列表'
					},
					// {
					// 	label: "网站地图",
					// 	value: '网站地图'
					// },
					{
						label: "购物车",
						value: '购物车'
					},
					{
						label: "个人中心",
						value: '个人中心'
					},
					{
						label: "我的收藏",
						value: '我的收藏'
					},
					{
						label: "我的订单",
						value: '我的订单'
					},
					// {
					// 	label: "特定页面",
					// 	value: '特定页面'
					// },
					{
						label: "具体文章",
						value: '具体文章'
					},
					{
						label: "文章分类",
						value: '文章分类'
					},
					// {
					// 	label: "商品品牌",
					// 	value: '商品品牌'
					// },
					// {
					// 	label: "固定链接",
					// 	value: '固定链接'
					// },
					{
						label: "自定义",
						value: '自定义'
					}
				],
				selectItem: ''
			}
		},
		// mounted() {
		// 	console.log('mounted', this.dataList)
		// },

		async mounted() {
			console.log('boxWidthmounted', this.boxWidth)
			console.log('dataList123', this.dataList)
			this.dataList.data.forEach(item => {
				if (item.cacheLinkIndex == '商品分类') {
					if (!item.followChild) {
						this.$set(item, 'followChild', false)
					}
					if (!item.followChildList) {
						this.$set(item, 'followChildList', [])
					}
				}
			})


			// config:{
			// 	color:"#000000", // 字体颜色
			// 	width:0,
			// 	isFull:true,
			// 	bg: {
			// 		bgType: "color", // color gradient
			// 		bgGradient: '',
			// 		bgColor: '#fff',
			// 		bgImg: {
			// 			url: '',
			// 			type: "",
			// 			position: "",
			// 			width: "",
			// 			height: ""
			// 		},
			// 	},
			// 	border: {
			// 		borderRadius: [0, 0, 0, 0],
			// 		borderSize: [0, 0, 0, 0],
			// 		radius: 0,
			// 		type: "solid",
			// 		px: 0,
			// 		color: ""
			// 	},
			// 	padding: [0, 0, 0, 0],
			// 	margin: [0, 0, 0, 0],
			// }

			this.dataList.data.forEach(item => {
				if (!item.config) {
					this.$set(item, 'config', {
						align: "left",
						titColor: "#000000",
						color: "#000000", // 字体颜色
						width: this.boxWidth ? this.boxWidth : 1200,
						isFull: true,
						bg: {
							bgType: "color", // color gradient
							bgGradient: '',
							bgColor: '#fff',
							bgImg: {
								url: '',
								type: "",
								position: "",
								width: "",
								height: ""
							},
						},
						border: {
							borderRadius: [0, 0, 0, 0],
							borderSize: [0, 0, 0, 0],
							radius: 0,
							type: "solid",
							px: 0,
							color: ""
						},
						padding: [0, 0, 0, 0],
						margin: [0, 0, 0, 0],
						titFontSize:18,
						titChildFontSize:14
					})
				}else{
					if(!item.config.titFontSize){
						this.$set(item.config, 'titFontSize', 18)
						
					}
					if(!item.config.titChildFontSize){
						this.$set(item.config, 'titChildFontSize', 14)
						
					}
				}
				if (item.child) {

					item.child.forEach(childItem => {
						if (!childItem.configWidth) {
							this.$set(childItem, 'configWidth', 250)
						}
					})
				}
			})


			if (this.dataList.data.length > 1) {
				this.selectItem = this.dataList.data[0].id
			} else {

				if (this.dataList.data.length == 0) {
					this.dataList.data.push({
						addBtn: true
					})
				}

			}
		},
		methods: {
			addChildFollowClassfiy(dataItem) {
				// let obj = lodash.cloneDeep(childObj)
				// obj.configWidth = 250
				let imgLink = []
				let text = []

				let imgTopItem;
				let textTopItem;
				this.systemConfig.locale_list.forEach(item => {

					if (item.code == this.systemConfig.locale) {
						imgTopItem = {
							language: item.code,
							languageName: item.name,
							url: item.url,
							link: {},
							img: {}
						}
						textTopItem = {
							language: item.code,
							languageName: item.name,
							url: item.url,
							text: dataItem.link.name
						}
					} else {
						imgLink.push({
							language: item.code,
							languageName: item.name,
							url: item.url,
							link: {},
							img: {}
						})
						text.push({
							language: item.code,
							languageName: item.name,
							url: item.url,
							text: dataItem.link.name
						})
					}

				})
				imgLink.unshift(imgTopItem)
				text.unshift(textTopItem)

				return {
					imgLink,
					text
				}
				// obj.imgLink = imgLink
				// obj.text = text
				// dataItem.child.push(lodash.cloneDeep(obj))
				// this.$forceUpdate()

			},

			async followChildChange(e, item) {
				if (e) {
					try {
						this.loadingPage = true
						let wsid = this.$cookies.get("wsid")
						const data = await designCategoriesSonCategory({
							wsid,
							id: item.link.id
						})

						if (data.data.data.length == 0) {
							item.followChildList = []
							this.loadingPage = false
							return
						}



						console.log('item', item)
						console.log('addChildFollowClassfiy', this.addChildFollowClassfiy(item))
						let {
							text,
							imgLink
						} = this.addChildFollowClassfiy(item)
						let arr = [{
							imgLink: imgLink,
							links: [],
							text: text,
							type: 1
						}]
						data.data.data.forEach(childItem => {
							arr[0].links.push({
								cacheLinkIndex: '商品分类',
								link: childItem,
								linkIndex: "商品分类" + ' - ' + childItem.name,
								linkList: this.addChildFollowLink(childItem)
							})
						})

						console.log('dataaaa', data)
						console.log('item', item)
						item.followChildList = arr
						this.loadingPage = false
					} catch (e) {
						this.loadingPage = false
					}
				}
			},
			marginSet(e, item) {
				if (this.marginAll) {
					item.margin = []
					item.margin.push(e.target.value)
					item.margin.push(e.target.value)
					item.margin.push(e.target.value)
					item.margin.push(e.target.value)
				}
			},
			paddingSet(e, item) {
				if (this.paddingAll) {
					item.padding = []
					item.padding.push(e.target.value)
					item.padding.push(e.target.value)
					item.padding.push(e.target.value)
					item.padding.push(e.target.value)
				}
			},


			levelChangeContainerSize(e, levelItem) {
				if (this.borderContainerSizeAll) {
					levelItem.border.borderSize = []
					levelItem.border.borderSize.push(e.target.value)
					levelItem.border.borderSize.push(e.target.value)
					levelItem.border.borderSize.push(e.target.value)
					levelItem.border.borderSize.push(e.target.value)
				}
			},
			handleDropdownOpen(isOpen, field) {
				if (isOpen) {
					this.$nextTick(() => {
						// 方案1：通过组件实例直接获取下拉框DOM（最精准）
						const dropdown = this.$refs[field].popperEl?.querySelector('.el-select-dropdown__wrap');

						// 方案2：如果方案1不生效，改用更暴力的全局查询（确保能命中）
						const dropdowns = document.querySelectorAll('.el-select-dropdown__wrap');
						const lastDropdown = dropdowns[dropdowns.length - 1];

						const target = dropdown || lastDropdown;
						if (target) {
							target.style.maxHeight = 'none';
							// 额外修复可能被覆盖的样式
							target.style.overflowY = 'visible';
						}
					});
				}
			},

			clearSelect(dataItem) {
				dataItem.link = {}
				dataItem.cacheLinkIndex = ''
				dataItem.linkIndex = ''
			},
			setLanguage(list) {
				console.log('setLanguagelist', list)
				let languageList = []
				let mainItem;
				list.forEach(listItem => {
					this.systemConfig.locale_list.forEach(item => {
						if (listItem.language == item.code) {
							listItem.url = item.url
							if (this.systemConfig.locale == item.code) {
								mainItem = listItem
							} else {
								languageList.push(listItem)
							}
						}
					})
				})

				if (mainItem) {
					languageList.unshift(mainItem)
				}
				return languageList
			},
			getList() {

			},
			endGrag(e) {
				console.log(this.selectItem)
				console.log('endGrag', this.dataList)
				console.log('endGrag', e)
			},
			delMain(dataItem, dataIndex, dataList) {
				this.$confirm('确认删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					console.log(dataItem, dataIndex, dataList)
					dataList.splice(dataIndex, 1)
					this.$forceUpdate()
				}).catch(() => {

				});
			},
			delImg(imgItem) {
				imgItem.img = {}
			},
			confirmSelectImg(e, type, dataItem) {
				console.log(e, type, dataItem)
				dataItem.img.url = e.url
				this.dialogVisibleImgs = false
			},
			addChildLink(childItem) {
				console.log('childItemchildItemchildItem', childItem)
				let linkList = []
				let topTtem;
				this.systemConfig.locale_list.forEach(item => {
					if (item.code == this.systemConfig.locale) {
						topTtem = {
							language: item.code,
							languageName: item.name,
							text: '',
							url: item.url
						}
					} else {
						linkList.push({
							language: item.code,
							languageName: item.name,
							text: '',
							url: item.url
						})
					}

				})
				linkList.unshift(topTtem)
				childItem.links.push({
					linkList
				})
			},

			addChildFollowLink(dataItem) {
				let linkList = []
				let topTtem;
				this.systemConfig.locale_list.forEach(item => {
					if (item.code == this.systemConfig.locale) {
						topTtem = {
							language: item.code,
							languageName: item.name,
							text: dataItem.name,
							url: item.url
						}
					} else {
						linkList.push({
							language: item.code,
							languageName: item.name,
							text: dataItem.name,
							url: item.url
						})
					}
				})
				linkList.unshift(topTtem)
				return linkList
			},


			addChild(dataItem) {
				console.log('addChildaddChildaddChild', dataItem)
				let obj = lodash.cloneDeep(childObj)
				obj.configWidth = 250
				let imgLink = []
				let text = []

				let imgTopItem;
				let textTopItem;
				this.systemConfig.locale_list.forEach(item => {

					if (item.code == this.systemConfig.locale) {
						imgTopItem = {
							language: item.code,
							languageName: item.name,
							url: item.url,
							link: {},
							img: {}
						}
						textTopItem = {
							language: item.code,
							languageName: item.name,
							url: item.url,
							text: ""
						}
					} else {
						imgLink.push({
							language: item.code,
							languageName: item.name,
							url: item.url,
							link: {},
							img: {}
						})
						text.push({
							language: item.code,
							languageName: item.name,
							url: item.url,
							text: ""
						})
					}

				})
				imgLink.unshift(imgTopItem)
				text.unshift(textTopItem)
				obj.imgLink = imgLink
				obj.text = text
				dataItem.child.push(lodash.cloneDeep(obj))
				this.$forceUpdate()

			},
			changeSearchDialogSearch(dataItem) {
				this.changeSelect(dataItem.cacheLinkIndex, dataItem, this.groupType)
				this.$forceUpdate()
			},
			confirmCustomerSelect(dataItem) {
				if (this.customerInput == '') {
					this.$message.error('请输入商品链接')
					return
				}
				dataItem.link = {
					name: this.customerInput,
					type: this.customerRadio
				}
				dataItem.linkIndex = dataItem.cacheLinkIndex + ' - ' + this.customerInput
				this.customerInput = ''
				this.customerVisible = false
				this.$forceUpdate()
			},
			confirmSelect(dataItem) {
				if (this.radio === '') {
					this.$message.error('请选择选项')
					return
				}
				dataItem.link = this.dialogList[this.radio]
				dataItem.linkIndex = dataItem.cacheLinkIndex + ' - ' + dataItem.link.name

				console.log('dataItem12341', dataItem)

				this.radio = ""
				this.dialogList = []
				this.dialogVisible = false
				this.$forceUpdate()
				console.log('dataItem', dataItem)
				this.selectKey = this.selectKey + 1

				if (dataItem.cacheLinkIndex == '商品分类' && dataItem.followChild) {
					this.followChildChange(dataItem.followChild, dataItem)
				}

			},
			changeRadio(e) {
				console.log('e', e)
				console.log(this.dialogList[e])
			},
			async changeSelect(e, dataItem, type) {
				console.log('e, dataItem, type', e, dataItem, type)


				this.groupType = type

				console.log('e', e)
				if (e == '无') {
					dataItem.link = {}
					dataItem.cacheLinkIndex = ''
					dataItem.linkIndex = ''
				}
				if (e == '商品') {
					dataItem.cacheLinkIndex = e
					this.dialogVisible = true
					await this.searchGoods(getProductsAutocomplete)
				}

				if (e == '商品分类') {
					dataItem.cacheLinkIndex = e
					this.dialogVisible = true
					await this.searchGoods(getCategoriesAutocomplete)
				}

				if (e == '特定页面') {
					dataItem.cacheLinkIndex = e
					this.dialogVisible = true
					await this.searchGoods(getPagesAutocomplete)
				}
				if (e == '文章分类') {
					dataItem.cacheLinkIndex = e
					this.dialogVisible = true
					await this.searchGoods(getPageCategoriesAutocomplete)
				}
				if (e == '商品品牌') {
					dataItem.cacheLinkIndex = e
					this.dialogVisible = true
					await this.searchGoods(getBrandsAutocomplete)
				}
				if (e == '具体文章') {
					dataItem.cacheLinkIndex = e
					this.dialogVisible = true
					await this.searchGoods(getPagesAutocomplete)
				}


				if (e == '首页') {
					dataItem.link = {
						name: "首页",
						url: ""
					}
					dataItem.linkIndex = '首页'
					dataItem.cacheLinkIndex = e
				}


				if (e == '热销商品') {
					dataItem.link = {
						name: "热销商品",
						url: "typeProducts/typeHot"
					}
					dataItem.linkIndex = '热销商品'
					dataItem.cacheLinkIndex = e
				}


				if (e == '最新商品') {
					dataItem.link = {
						name: "最新商品",
						url: "typeProducts/typeNew"
					}
					dataItem.linkIndex = '最新商品'
					dataItem.cacheLinkIndex = e
				}

				if (e == '浏览最多') {
					dataItem.link = {
						name: "浏览最多",
						url: "typeProducts/typevisit"
					}
					dataItem.linkIndex = '浏览最多'
					dataItem.cacheLinkIndex = e
				}


				if (e == '所有商品') {
					dataItem.link = {
						name: "所有商品",
						url: "typeProducts/typeAll"
					}
					dataItem.linkIndex = '所有商品'
					dataItem.cacheLinkIndex = e
				}


				if (e == '搜索页面') {
					dataItem.link = {
						name: "搜索页面",
						url: "search_center"
					}
					dataItem.linkIndex = '搜索页面'
					dataItem.cacheLinkIndex = e
				}


				if (e == '个人中心') {
					dataItem.link = {
						name: "个人中心",
						url: "account"


					}
					dataItem.linkIndex = '个人中心'
					dataItem.cacheLinkIndex = e
				}
				if (e == '我的收藏') {
					dataItem.link = {
						name: "我的收藏",
						url: "account/wishlist"

					}
					dataItem.linkIndex = '我的收藏'
					dataItem.cacheLinkIndex = e
				}
				if (e == '个人中心') {
					dataItem.link = {
						name: "个人中心",
						url: "account"
					}
					dataItem.linkIndex = '个人中心'
					dataItem.cacheLinkIndex = e
				}
				if (e == '我的订单') {
					dataItem.link = {
						name: "我的订单",
						url: "account/orders"

					}
					dataItem.linkIndex = '我的订单'
					dataItem.cacheLinkIndex = e
				}
				if (e == '品牌列表') {
					dataItem.link = {
						name: "品牌列表",
						url: "brandsPage",
					}
					dataItem.linkIndex = '品牌列表'
					dataItem.cacheLinkIndex = e
				}

				if (e == '购物车') {
					dataItem.link = {
						name: "购物车",
						url: "carts",
					}
					dataItem.linkIndex = '购物车'
					dataItem.cacheLinkIndex = e

				}



				if (e == '固定链接') {
					dataItem.cacheLinkIndex = e
					this.dialogVisible = true
					this.dialogList = [{
							name: "个人中心",
							url: "account"
						},
						{
							name: "我的收藏",
							url: "/account/wishlist"
						},
						{
							name: "我的订单",
							url: '/account/orders'
						},
						{
							name: "品牌列表",
							url: '/brandsPage'
						}
					]
				}
				if (e == '自定义') {
					dataItem.cacheLinkIndex = e
					this.customerVisible = true
				}
				this.$forceUpdate()

			},
			async searchGoods(api) {
				try {
					this.loading = true
					let wsid = this.$cookies.get("wsid")
					let data = await api({
						wsid,
						name: this.dialogSearch
					})
					this.dialogList = data.data.data
					this.loading = false
				} catch (e) {
					this.loading = false
				}
			},
			getText(e, type = 1) {
				console.log('getText', e)
				let text = ''
				console.log('systemConfig', this.systemConfig)
				e.text.forEach(item => {
					if (item.language == this.systemConfig.locale) {
						text = item.text
					}
				})
				if (text == '') {
					return type == 2 ? '请设置子菜单名称' : '请设置主菜单名称'
				} else {
					return text
				}
			},
			getLabel(e) {
				let text = ''
				e.label.forEach(item => {
					if (item.language == this.systemConfig.locale) {
						text = item.text
					}
				})
				if (text == '') {
					return '请添加标签名称'
				} else {
					return text
				}
			},
			addBtn(dataList, dataItem) {
				if (!dataItem.addBtn) {
					this.selectItem = dataItem.id
					return
				}
				dataList.splice(dataList.length - 1, 0, lodash.cloneDeep({
					...obj,
					id: new Date().getTime(),
					config: {
						align: "left",
						titColor: "#000000",
						color: "#000000", // 字体颜色
						width: this.boxWidth ? this.boxWidth : 1200,
						isFull: true,
						bg: {
							bgType: "color", // color gradient
							bgGradient: '',
							bgColor: '#fff',
							bgImg: {
								url: '',
								type: "",
								position: "",
								width: "",
								height: ""
							},
						},
						border: {
							borderRadius: [0, 0, 0, 0],
							borderSize: [0, 0, 0, 0],
							radius: 0,
							type: "solid",
							px: 0,
							color: ""
						},
						padding: [0, 0, 0, 0],
						margin: [0, 0, 0, 0],
					}
				}))

				if (this.dataList.data.length == 2) {
					this.selectItem = this.dataList.data[0].id
				}
			}

		}
	}
</script>

<style scoped lang="scss">
	::v-deep .el-input__inner:focus {
		border-color: #242754
	}

	.tit-icon:hover {
		color: #8c62ff;
	}

	input:focus {
		outline: none;
		border: 1px solid #242754;
		border-radius: 3px;
	}

	input {
		outline: none;
		border: 1px solid #c1c1c1;
		border-radius: 5px;

	}
</style>